export function getUrlQuery(name) {
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`)
  const r = window.location.search.substring(1).match(reg)
  if (r != null) {
    return decodeURI(r[2])
  }
}

export function defaultToEmptyString(value) {
  return value != null ? value : '';
}

export function isValidString (val) {
  return val !== null && val !== undefined && val !== ''
}

export function isEmptyArray (value) {
  return !(value === null || !value || value === '[]');
}

/**
 * 提取给定日期字符串中的年、月、日数字，并以数组形式返回
 * @param {string} dateStr - 包含日期的字符串
 * @returns {number[]} - 包含年、月、日数字的数组，如果输入为空则返回空数组
 */
export function extractDateParts(dateStr) {
  if (!dateStr) return []
  // 去除日期字符串中的非数字字符
  const dateParts = dateStr.replace(/[^\d]/g, ' ').split(' ').map(Number)
  // 返回提取出的年、月、日数字
  return [dateParts[0], dateParts[1], dateParts[2]]
}

/**
 * 从给定的 RTSP URL 中提取 IP 地址。
 *
 * @param {string} rtspUrl - 要解析的 RTSP URL。
 * @returns {string} 返回提取的 IP 地址，如果未找到，则返回 null。
 */
export function extractIpFromRtsp(rtspUrl) {
  const ipRegex = /rtsp:\/\/(?:[a-zA-Z0-9]+:?[a-zA-Z0-9]+@)?([0-9]+\.[0-9]+\.[0-9]+\.[0-9]+)/

  const matches = rtspUrl.match(ipRegex)

  if (matches && matches.length > 1) {
    return matches[1]
  }

  return ''
}


/**
 * 检查一个逗号分隔的字符串列表中是否包含指定的字符串。
 *
 * @param {string|null|undefined} listString - 一个逗号分隔的字符串，表示要检查的列表。可能为空字符串、null 或 undefined。
 * @param {string} searchString - 要查找的字符串。
 * @returns {boolean} 如果列表中包含要查找的字符串，则返回 true；否则返回 false。
 *
 * @example
 * containsSubstring("1,2,3,4", "3"); // 返回 true
 * containsSubstring("1,2,3,4", "5"); // 返回 false
 * containsSubstring("", "1");        // 返回 false
 * containsSubstring(null, "1");      // 返回 false
 * containsSubstring(undefined, "1"); // 返回 false
 */
export function containsSubstring(listString, searchString) {
  if (listString === null || listString === undefined) {
    return false;
  }

  const listArray = listString.split(',');

  return listArray.includes(searchString);
}


export function uniqueStringFromString(input) {
  if (!input) return ""

  let arr = input.split(',')
  let uniqueArr = Array.from(new Set(arr))
  return uniqueArr.join(',')
}

export function debounce(func, delay) {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}

export function convertToGMTString(beijingTime) {
  var beijingDateTime = new Date(beijingTime);
  var gmtDateTime = new Date(beijingDateTime.getTime());

  var year = gmtDateTime.getUTCFullYear();
  var month = ('0' + (gmtDateTime.getUTCMonth() + 1)).slice(-2); // 月份从0开始，需要加1，并且保证两位数格式
  var day = ('0' + gmtDateTime.getUTCDate()).slice(-2); // 日期保证两位数格式
  var hours = ('0' + gmtDateTime.getUTCHours()).slice(-2); // 小时保证两位数格式
  var minutes = ('0' + gmtDateTime.getUTCMinutes()).slice(-2); // 分钟保证两位数格式
  var seconds = ('0' + gmtDateTime.getUTCSeconds()).slice(-2); // 秒保证两位数格式

  return `${year}${month}${day}T${hours}${minutes}${seconds}Z`;
}

// 一小时的毫秒数
export const ONE_HOUR_STAMP = 60 * 60 * 1000
// 时间分辨率，即整个时间轴表示的时间范围
export const ZOOM = [0.5, 1, 2, 6, 12, 24, 72, 360, 720, 8760, 87600]// 半小时、1小时、2小时、6小时、12小时、1天、3天、15天、30天、365天、365*10天
// 时间分辨率对应的每格小时数，即最小格代表多少小时
export const ZOOM_HOUR_GRID = [1 / 60, 1 / 60, 2 / 60, 1 / 6, 0.25, 0.5, 1, 4, 4, 720, 7200]
export const MOBILE_ZOOM_HOUR_GRID = [
  1 / 20,
  1 / 30,
  1 / 20,
  1 / 3,
  0.5,
  2,
  4,
  4,
  4,
  720, 7200
]
// 时间分辨率对应的时间显示判断条件
export const ZOOM_DATE_SHOW_RULE = [
  () => { // 全部显示
    return true
  },
  date => { // 每五分钟显示
    return date.getMinutes() % 5 === 0
  },
  date => { // 每十分钟显示
    return date.getMinutes() % 10 === 0
  },
  date => { // 整点和半点显示
    return date.getMinutes() === 0 || date.getMinutes() === 30
  },
  date => { // 整点显示
    return date.getMinutes() === 0
  },
  date => { // 偶数整点的小时
    return date.getHours() % 2 === 0 && date.getMinutes() === 0
  },
  date => { // 每三小时小时
    return date.getHours() % 3 === 0 && date.getMinutes() === 0
  },
  date => { // 每12小时
    return date.getHours() % 12 === 0 && date.getMinutes() === 0
  },
  date => { // 全不显示
    return false
  },
  date => {
    return true
  },
  date => {
    return true
  }
]
export const MOBILE_ZOOM_DATE_SHOW_RULE = [
  () => { // 全部显示
    return true
  },
  date => { // 每五分钟显示
    return date.getMinutes() % 5 === 0
  },
  date => { // 每十分钟显示
    return date.getMinutes() % 10 === 0
  },
  date => { // 整点和半点显示
    return date.getMinutes() === 0 || date.getMinutes() === 30
  },
  date => { // 偶数整点的小时
    return date.getHours() % 2 === 0 && date.getMinutes() === 0
  },
  date => { // 偶数整点的小时
    return date.getHours() % 4 === 0 && date.getMinutes() === 0
  },
  date => { // 每三小时小时
    return date.getHours() % 3 === 0 && date.getMinutes() === 0
  },
  date => { // 每12小时
    return date.getHours() % 12 === 0 && date.getMinutes() === 0
  },
  date => { // 全不显示
    return false
  },
  date => {
    return true
  },
  date => {
    return true
  }
]

// 将手机号中间四位替换为星号
export function encryptPhoneNumber(phone) {
  return phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
}

/**
 * 名字脱敏方法（支持2-3个字脱敏中间）
 * @param {string} name - 原始名字
 * @param {object} options - 配置选项
 * @param {string} [options.maskChar='*'] - 脱敏替换字符
 * @param {boolean} [options.keepSingleChar=false] - 是否保留单字不脱敏
 * @returns {string} 脱敏后的名字
 */
export function desensitizeName(name, options = {}) {
  if (!name || typeof name !== 'string') return name;

  const { maskChar = '*', keepSingleChar = false } = options;
  const length = name.length;

  // 处理单字情况
  if (length === 1) {
    return name;
  }

  // 处理2-3个字的情况
  if (length === 2 || length === 3) {
    // 2个字：脱敏第二个字
    // 3个字：脱敏中间字
    const firstChar = name.charAt(0);
    const lastChar = length === 2 ? '' : name.charAt(2);

    return firstChar + maskChar + lastChar;
  }

  // 超过3个字的名字，可以按需处理或返回原样
  return name;
}


export function truncateToTwoDecimalPlaces(num) {
  return Math.floor(num * 100) / 100;
}


/**
 * 定义图片方向的类型
 */
export const ImageOrientation = {
  LANDSCAPE: "landscape", // 横向图片
  PORTRAIT: "portrait",   // 纵向图片
  SQUARE: "square",       // 正方形图片
};

/**
 * 判断图片的宽高比，返回图片方向类型
 * @param {string} imageUrl 图片的URL
 * @returns {Promise<ImageOrientation>} 返回一个 Promise，解析为 ImageOrientation 类型
 */
export function checkImageOrientation(imageUrl) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = imageUrl;

    img.onload = function () {
      const width = this.width;
      const height = this.height;

      if (width > height) {
        resolve(ImageOrientation.LANDSCAPE);
      } else if (width < height) {
        resolve(ImageOrientation.PORTRAIT);
      } else {
        resolve(ImageOrientation.SQUARE);
      }
    };

    img.onerror = function () {
      reject(new Error("图片加载失败"));
    };
  });
}

// 修改为数组
export const AUTH_TYPE_ARRAY = [
  {
    value: '1',
    label: '楼道堆物AI'
  },
  {
    value: '2',
    label: '消防车道AI'
  },
  {
    value: '3',
    label: '电动车AI'
  },
  {
    value: '4',
    label: '电瓶AI'
  },
  {
    value: '5',
    label: '火眼AI'
  },
  {
    value: '6',
    label: '垃圾溢满AI'
  },
  {
    value: '7',
    label: '防火门AI'
  }
]

export const  allBuildingType = [
  {
    value: '重点人',
    label: '重点人'
  },
  {
    value: '大屋脊',
    label: '大屋脊'
  },
  {
    value: '平房院',
    label: '平房院'
  },
  {
    value: '楼房',
    label: '楼房'
  },
  {
    value: '九小门店',
    label: '九小门店'
  },
  {
    value: '其他',
    label: '其他'
  }
]

export function getDepthInCm(liquidLevel) {
  if (liquidLevel === '0') return 0;
  return (parseInt(liquidLevel) / 10).toFixed(1);
}


export const allDhlrType = {
  1: "动火离人",
  2: "未穿厨师服",
  3: "未戴厨师帽",
  4: "老鼠检测",
  5: "未戴口罩"
};

// 或者如果你需要函数形式：
export function getAllDhlrType(type) {
  return allDhlrType[type] || '报警';
}



// WEBPACK FOOTER //
// ./src/js/common.js